export default __webpack_public_path__ + "static/media/gallery-h-2.33c446e2.png";